// extracted by mini-css-extract-plugin
export default {"register":"Register_register__jwtxP","registerForm":"Register_registerForm__XWkrC","registerButton":"Register_registerButton__PBUTn","registerInfos":"Register_registerInfos__cpkZJ"};